import { useSearchParams } from 'react-router';

import { Icon } from '../../components/Icon/Icon';
import { flowStepOf } from '../auth/flowUrl';
import styles from './WelcomeSongControl.module.css';
import { startWelcomeSong, stopWelcomeSong, useWelcomeSong } from './welcomeSong';

/**
 * Control flotante de la melodía de bienvenida: "Silenciar" mientras suena y "Escuchar" si el
 * navegador no la dejó sonar sola (el toque es el gesto que necesita). Sin melodía no pinta nada, y
 * con el registro abierto tampoco: ahí la reemplaza la alerta "Escúchanos" del diálogo.
 */
export function WelcomeSongControl() {
  const state = useWelcomeSong();
  const [params] = useSearchParams();
  if (state === 'idle' || flowStepOf(params) !== null) return null;

  return (
    <div className={styles.control} role="status">
      <span className={styles.badge} aria-hidden="true">
        <Icon name="musica" size={20} />
      </span>
      {state === 'playing' ? (
        <>
          <p className={styles.text}>
            <b>El Parche Cafetero</b>
            <br />
            Suena tu bienvenida a la ruta
          </p>
          <button type="button" className={styles.action} onClick={stopWelcomeSong}>
            <Icon name="silencio" size={18} />
            Silenciar
          </button>
        </>
      ) : (
        <>
          <p className={styles.text}>
            <b>Tu bienvenida tiene música</b>
            <br />
            Toca para escucharla
          </p>
          <button type="button" className={styles.action} onClick={startWelcomeSong}>
            <Icon name="musica" size={18} />
            Escuchar
          </button>
          <button type="button" className={styles.dismiss} onClick={stopWelcomeSong} aria-label="Descartar la música">
            <Icon name="x" size={18} />
          </button>
        </>
      )}
    </div>
  );
}
